module.exports = __webpack_public_path__ + "public/img/image-7.aa966f7c.png";